'use strict';

var request = require('./request');

var PATH = 'module-instance';

var ModuleInstanceApi = {
  load: function load(params) {
    return request.get(PATH, params);
  },

  details: function details(id, params) {
    return request.get(PATH + '/' + id, params);
  },

  add: function add(params) {
    return request.post(PATH, params);
  },

  update: function update(id, params) {
    return request.put(PATH + '/' + id + '/position', params);
  },

  performAction: function performAction(id, params) {
    return request.post(PATH + '/' + id + '/action', params);
  },

  'delete': function _delete(ids) {
    return request['delete'](PATH + '/' + ids.join(','));
  },

  save: function save(id, params) {
    return request.put(PATH + '/' + id + '/state', params);
  }
};

module.exports = ModuleInstanceApi;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/api/module.js
 **/